import { Skeleton } from '@/components/ui/skeleton';

/**
 * PageLoader - Loading fallback for lazy-loaded pages
 * Used with React.Suspense for route-based code splitting
 */
export function PageLoader() {
  return (
    <div className="page-padding space-y-6 animate-in fade-in duration-300">
      {/* Page header skeleton */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-64 bg-navy-800" />
        <Skeleton className="h-10 w-32 bg-navy-800" />
      </div>

      {/* Main content skeleton */}
      <Skeleton className="h-64 w-full bg-navy-800" />

      {/* Card grid skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Skeleton className="h-32 bg-navy-800" />
        <Skeleton className="h-32 bg-navy-800" />
        <Skeleton className="h-32 bg-navy-800" />
      </div>

      {/* Table skeleton */}
      <div className="space-y-2">
        <Skeleton className="h-10 w-full bg-navy-800" />
        <Skeleton className="h-10 w-full bg-navy-800" />
        <Skeleton className="h-10 w-full bg-navy-800" />
        <Skeleton className="h-10 w-full bg-navy-800" />
      </div>
    </div>
  );
}

export default PageLoader;
